import React from 'react';
import stylesBreadcrumb from './breadcrumb.module.css.js';
import classNames from 'classnames';

function Breadcrumb({ 'data-testid': dataTestId, iconClassName, image, name }) {
    return (React.createElement("span", { "data-testid": dataTestId, className: stylesBreadcrumb.breadcrumb },
        iconClassName && React.createElement("i", { className: classNames(stylesBreadcrumb.icon, 'bc-icon', `bc-${iconClassName}`), role: 'img' }),
        image && !iconClassName && React.createElement("img", { src: image, alt: name, className: stylesBreadcrumb.icon }),
        React.createElement("span", { className: stylesBreadcrumb.text }, name)));
}

export { Breadcrumb };
